import {
  Component,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  ElementRef,
  ViewChild,
} from "@angular/core"
import { LexTranslateService } from "@app/core/services/lex-translate.service"

type LexButtonVariants = "grayLight" | "grayDark" | "primary" | "outline"

@Component({
  selector: "lex-button",
  templateUrl: "./lex-button.component.html",
  styleUrls: ["./lex-button.component.css"],
})
export class LexButtonComponent implements AfterViewInit {
  @ViewChild("button") button: ElementRef<HTMLButtonElement>

  @Input() label: string
  @Input() containerStyle: string = ""
  @Input() buttonClass: string = ""
  @Input() icon: string
  @Input() variant: LexButtonVariants = "primary"
  @Input() isDisabled: boolean = false

  @Output() onClick: EventEmitter<void> = new EventEmitter()

  constructor(public lextranslate: LexTranslateService) {}

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()
  }

  handleOnClick() {
    this.onClick.emit()
  }

  ngAfterViewInit() {
    if (!this.button.nativeElement) return

    this.button.nativeElement.setAttribute("style", this.containerStyle)
  }
}
